export { WorldPayCardPaymentComponent } from './world-pay-card-payment/world-pay-card-payment.component';
export { WorldPayCardPaymentModule } from './world-pay-card-payment/world-pay-card-payment.module';
